import { useState } from "react";
import SectionHeading from "./SectionHeading";
import { bingeGuides } from "@/mocks/anime";

const colorMap: Record<string, string> = {
  primary: "bg-primary-100 text-primary-800",
  accent: "bg-accent-100 text-accent-900",
  secondary: "bg-secondary-100 text-secondary-900",
};

export default function BingeGuide() {
  const [activeId, setActiveId] = useState(bingeGuides[0].id);
  const active = bingeGuides.find((guide) => guide.id === activeId) || bingeGuides[0];

  return (
    <section id="guide" className="w-full px-4 md:px-8 py-16 md:py-24 bg-background-50">
      <SectionHeading
        eyebrow="看什么 · 按什么顺序看"
        icon="ri-road-map-line"
        title="补番指南 · 四条可以直接照着走的路线"
        description="补番不只是挑一部开始看，顺序往往更重要。下面把不同类型的作品整理成四条路线，从入门到专题各有侧重，点左侧任意一条即可查看具体顺序。"
      />

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-8">
        <div className="lg:col-span-5 flex flex-col gap-3">
          {bingeGuides.map((guide) => {
            const isActive = guide.id === activeId;
            return (
              <button
                key={guide.id}
                type="button"
                onClick={() => setActiveId(guide.id)}
                aria-pressed={isActive}
                className={`text-left rounded-lg p-4 md:p-5 border transition-colors cursor-pointer ${
                  isActive
                    ? "bg-primary-500 border-primary-500"
                    : "bg-background-100 border-background-200/70 hover:border-primary-300"
                }`}
              >
                <div className="flex items-center justify-between gap-3">
                  <h3
                    className={`font-heading font-bold text-base md:text-lg ${
                      isActive ? "text-background-50" : "text-foreground-950"
                    }`}
                  >
                    {guide.title}
                  </h3>
                  <i
                    className={`ri-arrow-right-line text-lg ${
                      isActive ? "text-background-50" : "text-foreground-400"
                    }`}
                    aria-hidden="true"
                  ></i>
                </div>
                <div className="mt-2 flex items-center gap-2">
                  <span
                    className={`px-2.5 py-0.5 rounded-full text-xs ${
                      isActive ? "bg-background-50/20 text-background-50" : colorMap[guide.color]
                    }`}
                  >
                    {guide.level}
                  </span>
                  <span className={`text-xs ${isActive ? "text-background-100" : "text-foreground-500"}`}>
                    {guide.steps.length} 个步骤
                  </span>
                </div>
              </button>
            );
          })}
        </div>

        <div className="lg:col-span-7">
          <div className="rounded-lg bg-background-100 border border-background-200/70 p-5 md:p-7">
            <div className="flex items-center gap-3 pb-4 border-b border-background-200">
              <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-route-line text-2xl" aria-hidden="true"></i>
              </span>
              <div>
                <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-950">
                  {active.title}
                </h3>
                <p className="text-xs text-foreground-500">{active.steps.length} 个观看步骤</p>
              </div>
            </div>

            <ol className="mt-5 space-y-4">
              {active.steps.map((step, index) => (
                <li key={step} className="flex gap-4">
                  <span className="relative flex flex-col items-center">
                    <span className="w-8 h-8 shrink-0 flex items-center justify-center rounded-full bg-accent-500 text-foreground-950 text-sm font-bold">
                      {index + 1}
                    </span>
                    {index < active.steps.length - 1 && (
                      <span className="flex-1 w-px bg-background-300 my-1" aria-hidden="true"></span>
                    )}
                  </span>
                  <p className="pt-1 text-sm md:text-base leading-relaxed text-foreground-700">
                    {step}
                  </p>
                </li>
              ))}
            </ol>

            <div className="mt-6 flex items-center gap-2 rounded-md bg-secondary-50 border border-secondary-200 px-4 py-3">
              <i className="ri-lightbulb-line text-secondary-700 text-lg" aria-hidden="true"></i>
              <p className="text-xs md:text-sm text-secondary-900">
                提示：先看完正片再补外传与特别篇，剧情理解会更顺畅。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}